import type { FC } from "react";

import Menu from "menu";

const App: FC = () => <Menu />

export default App;